<template>
  <donut-chart-card
    :size="size"
    :title="title"
    :value="data"
    :init-total="total"
    :unit="unit"
    :isMoveWrite="isMoveWrite"
    :is-move-detail="!!projectId"
    :orientation="orientation"
    @detail="onClickDetail"
    @write="onClickWrite"
  ></donut-chart-card>
</template>

<script>
/* eslint-disable brace-style */
import DonutChartCard from "@/components/DonutChartCard";

export default {
  name: "DonutChart02",
  components: { DonutChartCard },
  props: {
    dataType: "detail" | "field" | "address" | "field_cat1" | "company" | "project",
    size: String,
    reloadCount: Number,
    orientation: {
      type: "landscape" | "portrait",
      default: () => "portrait",
    },
    title: {
      type: String,
      default: () => "종사자 현황",
    },
    unit: {
      type: String,
      default: () => "명",
    },
    fieldCode: {
      type: String,
      default: undefined,
    },
    graphId: {
      type: Number,
      default: () => 2,
    },
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    isMoveWrite() {
      // if (Number(`${this.projectId}`) === 1) return false
      // else return true
      return true;
    },
    getLevel() {
      const projects = this.$store.state.member.memberInfo.projects;
      if (projects) {
        for (const project of projects) {
          if (`${project.id}` === `${this.projectId}` && project.company.length > 0) {
            const path = project.company[0].pivot.company_path;
            return path.split("/").length - 1; // Level
          }
        }
      }
    },
  },
  watch: {
    dataType(/*value*/) {
      this.loadGraph();
    },
  },
  data() {
    return {
      data: [{ label: "데이터 없음", value: 0 }],
      total: "0",
    };
  },
  async mounted() {
    await this.loadGraph();
  },
  methods: {
    async loadDetailData() {
      const currentYear = new Date().getFullYear();
      const currentMonth = (new Date().getMonth() + 1).toString().padStart(2, "0");
      const lastDay = new Date(currentYear, currentMonth, 0).getDate();

      const cacheKey = `detail_02_${currentYear}_${currentMonth}_v02`;

      // 캐시에 저장되어 있으면, 캐시에서 불러온다
      const cachedSessionData = sessionStorage.getItem(cacheKey);
      if (cachedSessionData) {
        const cachedItem = JSON.parse(cachedSessionData);
        const now = new Date().getTime();
        // 10분 (10 * 60 * 1000 밀리초) 내의 캐시인지 확인
        if (cachedItem && cachedItem.timestamp && now - cachedItem.timestamp < 600000) {
          return cachedItem.data; // 캐시된 데이터 반환
        } else {
          sessionStorage.removeItem(cacheKey); // 만료된 캐시 제거
        }
      }

      const payload = {
        projectId: this.projectId,
        page: 1,
        perPage: 10000,
        // to_retirement_date: `${currentYear}-${String(currentMonth).padStart(2, "0")}-${String(lastDay).padStart(2, "0")}`,
        to_retirement_date: `${currentYear}-12-31`,
      };
      const response = await this.$store.dispatch("employee/LOAD_EMPLOYEE_LIST", payload);
      const tempFieldList = {};

      response.data.forEach((item) => {
        // hire_date : 입사일
        const hireDate = new Date(item.hire_date);
        // retirement_date : 퇴사일
        const retireDate = new Date(item.retirement_date);

        // 잘못된 날짜 순서라면 제외
        // id 119 데이터가 hire_date: "2025-12-02", retirement_date:"2025-11-30" 라서 추가했음
        if (retireDate < hireDate) return;

        // 비교 대상일 (2025-08-31)
        const targetDateStr = `${currentYear}-${String(currentMonth).padStart(2, "0")}-${String(lastDay).padStart(2, "0")}`;
        const targetDate = new Date(targetDateStr);

        // 입사일이 targetDate 이후면 제외
        if (hireDate > targetDate) return;

        // 퇴사일이 targetDate의 전월 마지막일 (2025-07-31) 이전이면 제외
        const prevMonthLastDate = new Date(currentYear, currentMonth - 1, 0);
        if (retireDate < prevMonthLastDate) return;

        item.fields.map((field) => {
          const comNameEntry = field.meta_info.find((item) => item.meta_key === "com_name");
          const comName = comNameEntry ? comNameEntry.meta_value : null;

          if (tempFieldList[comName]) tempFieldList[comName]++;
          else tempFieldList[comName] = 1;
        });
      });

      const data = Object.entries(tempFieldList).map(([label, count]) => ({
        label,
        count,
      }));

      // sessionStorage에 데이터와 타임스탬프 저장
      const itemToCache = { data, timestamp: new Date().getTime() };
      sessionStorage.setItem(cacheKey, JSON.stringify(itemToCache));

      return data;
    },
    async loadGraph() {
      const data = await this.loadDetailData();

      const rowSum = data.reduce((acc, row) => {
        return acc + row.count;
      }, 0);
      data.sort((a, b) => b.count - a.count);

      const list = [];
      let no = 1;

      for (const row of data) {
        list.push({
          label: row.label,
          value: row.count,
        });
        no += 1;

        if (no > 5) break;
      }

      this.data = list;
      this.total = rowSum;
    },
    onClickDetail() {
      const projectId = this.$route.params.proj_id;
      const graphId = this.graphId;
      if (projectId) {
        this.$router.push(`/project/${projectId}/graph-detail/${graphId}`);
      } else {
        this.$router.push(`/graph-detail/${graphId}`);
      }
    },
    onClickWrite() {
      const proj_id = this.$route.params.proj_id;
      const boardId = `${this.boardId}`;
      this.$router.push({ name: "write|tab", params: { proj_id, boardId } });
    },
  },
};
</script>

<style scoped></style>
